import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { getPaymentStatus } from '../../../services/stripeService';
import './Pricing.css';

const SubscriptionSuccess = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const MySwal = withReactContent(Swal);
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('Vérification du paiement...');
    const hasVerified = useRef(false); // Flag pour éviter les appels multiples

    useEffect(() => {
        const verifyPaymentAndSaveSubscription = async () => {
            if (hasVerified.current) {
                console.log('⏭️ Vérification déjà effectuée, skip');
                return;
            }
            
            hasVerified.current = true;
            
            try {
                const sessionId = searchParams.get('session_id');
                
                if (!sessionId) {
                    setStatus('error');
                    setMessage('Session de paiement introuvable');
                    return;
                }

                // Récupérer les infos du plan depuis localStorage
                const pendingSubscription = JSON.parse(localStorage.getItem('pending_subscription'));
                
                if (!pendingSubscription) {
                    setStatus('error');
                    setMessage('Informations d\'abonnement introuvables');
                    return;
                }

                const { plan } = pendingSubscription;

                // Vérifier le statut du paiement Stripe
                setMessage('Vérification du paiement Stripe...');
                const paymentStatus = await getPaymentStatus(sessionId, { abonnement: true });
                
                console.log('💳 Payment status:', paymentStatus);

                if (paymentStatus.status !== 'paid') {
                    setStatus('error');
                    setMessage('Le paiement n\'a pas été complété');
                    return;
                }

                // Le serveur a vérifié le paiement chez Stripe et enregistré lui-même
                // l'abonnement (prélèvement mensuel automatique)
                const abonnement = paymentStatus.abonnement;
                if (!abonnement) {
                    throw new Error("L'abonnement n'a pas pu être enregistré");
                }

                const user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    user.dernier_abonnement = abonnement;
                    localStorage.setItem('user', JSON.stringify(user));
                }
                localStorage.removeItem('pending_subscription');

                setStatus('success');
                setMessage('Votre abonnement a été activé avec succès !');

                MySwal.fire({
                    icon: 'success',
                    html: `
                        <div style="text-align: center;">
                            <p style="color: #666; margin: 15px 0;">
                                Votre abonnement <strong>${plan.name}</strong> est maintenant actif.
                            </p>
                            <p style="color: #28a745; font-weight: bold;">
                                Renouvelé automatiquement chaque mois (prochaine échéance : ${new Date(abonnement.date_fin).toLocaleDateString('fr-FR')})
                            </p>
                        </div>
                    `,
                    confirmButtonText: 'Accéder à mes restaurants',
                    confirmButtonColor: '#FF6B2C',
                    allowOutsideClick: false,
                }).then(() => {
                    navigate('/restaurants');
                });

            } catch (error) {
                console.error('❌ Error:', error);
                
                // Réinitialiser le flag en cas d'erreur pour permettre un retry
                hasVerified.current = false;
                
                setStatus('error');
                setMessage(error.message || 'Une erreur est survenue');
                
                MySwal.fire({
                    icon: 'error',
                    // title: 'Erreur',
                    text: error.message || 'Une erreur est survenue lors de l\'activation de votre abonnement.',
                    confirmButtonText: 'Réessayer',
                    confirmButtonColor: '#FF6B2C',
                }).then(() => {
                    navigate('/pricing');
                });
            }
        };

        verifyPaymentAndSaveSubscription();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="pricing-component">
            <div className="pricing-container" style={{ textAlign: 'center', padding: '60px 20px' }}>
                {status === 'loading' && (
                    <>
                        <div style={{ marginBottom: '30px' }}>
                            <div 
                                className="spinner-border text-primary" 
                                role="status" 
                                style={{ width: '4rem', height: '4rem' }}
                            >
                                <span className="sr-only">Chargement...</span>
                            </div>
                        </div>
                        <h2 style={{ color: '#333', marginBottom: '16px' }}>Traitement en cours...</h2>
                        <p style={{ color: '#666', fontSize: '16px' }}>{message}</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <div style={{ fontSize: '80px', marginBottom: '20px' }}>🎉</div>
                        <h2 style={{ color: '#28a745', marginBottom: '16px' }}>Paiement réussi !</h2>
                        <p style={{ color: '#666', fontSize: '16px' }}>{message}</p>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div style={{ fontSize: '80px', marginBottom: '20px' }}>❌</div>
                        <h2 style={{ color: '#dc3545', marginBottom: '16px' }}>Erreur</h2>
                        <p style={{ color: '#666', fontSize: '16px' }}>{message}</p>
                        <button
                            onClick={() => navigate('/pricing')}
                            style={{
                                marginTop: '20px',
                                padding: '12px 30px',
                                backgroundColor: '#FF6B2C',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer'
                            }}
                        >
                            Retour aux tarifs
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default SubscriptionSuccess;
